import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import axios from 'axios'

import { routeTree } from './routeTree.gen'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      // Não retenta erros 4xx (ex.: 404 de conversa que não pertence à org ativa
      // após trocar de org) — só vale repetir falhas transitórias (5xx/rede).
      retry: (failureCount, error) => {
        const status = axios.isAxiosError(error)
          ? error.response?.status
          : undefined
        if (status && status >= 400 && status < 500) return false
        return failureCount < 1
      },
    },
  },
})

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPendingComponent: RoutePendingSkeleton,
})

function RoutePendingSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4 p-6">
      <div className="bg-muted h-8 w-64 animate-pulse rounded-md" />
      <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="bg-muted h-24 animate-pulse rounded-md" />
        ))}
      </div>
      <div className="bg-muted h-72 w-full animate-pulse rounded-md" />
    </div>
  )
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
